module.exports = __webpack_public_path__ + "static/media/dayLimitPower1.f0a3cbd6.svg";